import { ReactNode, useMemo } from 'react';
import SkeletonFundedAccountsList from '../FundedAccount/Skeleton';

export default function SkeletonFindedAccounts() {
  const SkeletonArray: ReactNode[] = useMemo(
    () =>
      Array.from({ length: 3 }, (_, index) => (
        <SkeletonFundedAccountsList
          key={`skeleton-account-list-item${index}`}
        />
      )),
    [],
  );

  return SkeletonArray;
}
